import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from './Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
//import 'moment-duration-format';

import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormComponent from '../FormComponent';

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';
import FormTextArea from '../form/FormTextArea';
import PtoRequestContainer from '../../containers/PtoRequest';

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 20,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		removeButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
			color: 'white',
			marginRight: 10,
			backgroundColor: `#f44336`,
		},

		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		pleaseSelect: {
			fontStyle: 'italic',
			color: '#777',
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
	};
}

class DenyOrCancelPtoRequest extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving: false,
			savingSuccessful: false,
		};
	}

	handleSubmit = () => {
		const { ptoRequest, updateToStatus, updatePtoRequest, showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			return showErrors(_.values(formFieldError));
		}

		const { ptoRequestId } = this.props;
		const { note } = this.state;

		if (!ptoRequestId) {
			return showErrors(['Missing ptoRequestId.']);
		}

		const { status } = ptoRequest;
		const isWaitingForSupervisorApproval = status === 'pendingSupervisorApproval';
		const isWaitingForHrApproval = status === 'pendingHrApproval';

		let action;
		if (updateToStatus === 'deny') {
			if (isWaitingForSupervisorApproval) {
				action = 'supervisorDeny';
			} else if (isWaitingForHrApproval) {
				action = 'hrDeny';
			}
		} else if (updateToStatus === 'cancel') {
			if (isWaitingForSupervisorApproval) {
				action = 'supervisorCancel';
			} else if (isWaitingForHrApproval) {
				action = 'hrCancel';
			}
		} else {
			return showErrors([`Invalid updateToStats:${updateToStatus}`]);
		}

		const params = {
			ptoRequestId,
			note,
			action,
		};

		this.setState({ isSaving: true, savingSuccessful: false });
		updatePtoRequest({
			params,
			callback: (err, apiResult) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}
				_.delay(() => {
					this.props.afterSave({ apiResult });
					this.handleClose();
				}, 400);
			},
		});
	};

	handleClose = () => {
		this.setState({
			savingSuccessful: false,
			isSaving: false,
		});
		this.props.onClose();
	};

	render() {
		const { open, updateToStatus, classes } = this.props;

		const isRequired = true;
		const { isSaving, savingSuccessful } = this.state;

		const action = _.startCase(updateToStatus);

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>{action} an Employees PTO Request</div>
						<div>
							<IconButton
								aria-label="close"
								className={classes.closeButton}
								onClick={this.handleClose}
							>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<form>
						<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
							<FormTextArea
								{...this.setForm('note', `Reason for PTO Request ${updateToStatus}`, isRequired)}
								rows={2}
							/>

							<Grid item md={12}>
								<strong style={{ fontSize: '120%' }}>
									Are you sure you want to {updateToStatus} this PTO Request?
								</strong>
							</Grid>
							<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
								<Button
									variant="contained"
									color="secondary"
									className={classes.removeButton}
									onClick={this.handleSubmit}
									disabled={isSaving || savingSuccessful}
								>
									Yes, I want to {updateToStatus} this employee PTO Request
								</Button>

								<Button variant="outlined" className={classes.button} onClick={this.handleClose}>
									Close
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter
									unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{ verticalAlign: 'middle' }} />
										<span style={{ paddingLeft: 10 }}>Saving...</span>
									</div>
								</Zoom>

								<Zoom
									in={savingSuccessful}
									style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
								>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon} />
										<span style={{ paddingLeft: 10 }}>PTO Request {action} successfully.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}
}

DenyOrCancelPtoRequest.propTypes = {
	updateToStatus: PropTypes.string.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func,
	afterSave: PropTypes.func.isRequired,
	updatePtoRequest: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	PtoRequestContainer,
])(DenyOrCancelPtoRequest);
